import './App.css';
import Rout from './Routes/Rout';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import Layout from './components/Layout/Layout';




function App() {
  return (
    <div className="App">
     <Layout />
    </div>
  );
}

export default App;
